import { api } from "./api";
import type {
  LoginRequestDTO,
  LoginResponseDTO,
  ForgotPasswordRequestDTO,
  ResetPasswordRequestDTO,
  RegisterRequestDTO,
  UserResponseDTO,
  ApiResponse,
} from "../../shared/dto";

const publicRoutes = "/auth/public";
const privateRoutes = "/auth/private";
export const authService = {
  register: (data: RegisterRequestDTO) =>
    api.post<ApiResponse<UserResponseDTO>>(`${publicRoutes}/register`, data),
  login: (credentials: LoginRequestDTO) =>
    api.post<ApiResponse<LoginResponseDTO>>(
      `${publicRoutes}/login`,
      credentials,
    ),
  refresh: (refreshToken: string) =>
    api.post<ApiResponse<LoginResponseDTO>>(`${publicRoutes}/refresh`, {
      refreshToken,
    }),
  logout: (refreshToken: string) =>
    api.post<ApiResponse<void>>(`${privateRoutes}/logout`, { refreshToken }),
  forgotPassword: (data: ForgotPasswordRequestDTO) =>
    api.post<ApiResponse<void>>(`${publicRoutes}/forgot-password`, data),
  resetPassword: (data: ResetPasswordRequestDTO) =>
    api.post<ApiResponse<void>>(`${publicRoutes}/reset-password`, data),
};
